import React from 'react';
import { Form, InputNumber, DatePicker } from 'antd';
import { theme } from '../../../theme';
import dayjs from 'dayjs';

interface DetallesContratoProps {
  formData: {
    tarafardo: number;
    kilos: number;
    precio: number;
    fecha_contrato: string;
    fecha_cierre: string;
  };
  productoType?: number;
  onFieldChange: (field: string, value: any) => void;
}

export const DetallesContrato: React.FC<DetallesContratoProps> = ({
  formData,
  productoType,
  onFieldChange
}) => {
  const taraFardoDisabled = productoType === 3;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '16px' }}>
      <Form.Item
        label={<span style={{ color: theme.colors.textPrimary, fontWeight: 500 }}>Tara Fardo</span>}
        style={{ marginBottom: 0 }}
      >
        <InputNumber
          style={{ width: '100%' }}
          min={0}
          step={0.001}
          value={formData.tarafardo}
          onChange={(value) => onFieldChange('tarafardo', value || 0)}
          disabled={taraFardoDisabled}
          size="small"
          placeholder="Ej: 0.250"
        />
      </Form.Item>

      <Form.Item
        label={<span style={{ color: theme.colors.textPrimary, fontWeight: 500 }}>Kilos</span>}
        required
        style={{ marginBottom: 0 }}
      >
        <InputNumber
          style={{ width: '100%' }}
          min={0}
          step={0.001}
          value={formData.kilos}
          onChange={(value) => onFieldChange('kilos', value || 0)}
          size="small"
          placeholder="Ej: 1000"
        />
      </Form.Item>

      <Form.Item
        label={<span style={{ color: theme.colors.textPrimary, fontWeight: 500 }}>Precio</span>}
        style={{ marginBottom: 0 }}
      >
        <InputNumber
          style={{ width: '100%' }}
          min={0}
          step={0.001}
          value={formData.precio}
          onChange={(value) => onFieldChange('precio', value || 0)}
          size="small"
          placeholder="Ej: 150.50"
        />
      </Form.Item>

      <Form.Item
        label={<span style={{ color: theme.colors.textPrimary, fontWeight: 500 }}>Fecha Contrato</span>}
        required
        style={{ marginBottom: 0 }}
      >
        <DatePicker
          style={{ width: '100%' }}
          format="DD/MM/YYYY"
          value={formData.fecha_contrato ? dayjs(formData.fecha_contrato) : null}
          onChange={(date) => onFieldChange('fecha_contrato', date ? date.format('YYYY-MM-DD') : '')}
          size="small"
          placeholder="Seleccionar fecha"
        />
      </Form.Item>

      <Form.Item
        label={<span style={{ color: theme.colors.textPrimary, fontWeight: 500 }}>Fecha Cierre</span>}
        style={{ marginBottom: 0 }}
      >
        <DatePicker
          style={{ width: '100%' }}
          format="DD/MM/YYYY"
          value={formData.fecha_cierre ? dayjs(formData.fecha_cierre) : null}
          onChange={(date) => onFieldChange('fecha_cierre', date ? date.format('YYYY-MM-DD') : '')}
          size="small"
          placeholder="Seleccionar fecha"
        />
      </Form.Item>
    </div>
  );
};

